import React from "react";
import {
  Account,
  Contracts,
  Diamond,
  Magnet,
  Partners,
  People
} from "@dreamhub/designsystem/icons";
import { EntityType } from "@/components/ui/entity-type";

export const getEntityIcon = (entityType: EntityType): React.ReactNode => {
  switch (entityType) {
    case EntityType.DEAL:
      return <Diamond />;
    case EntityType.COMPANY:
      return <Account />;
    case EntityType.PERSON:
    case EntityType.PARTNER_CONTACT:
      return <People />;
    case EntityType.LEAD:
      return <Magnet />;
    case EntityType.CONTRACT:
      return <Contracts />;
    case EntityType.PARTNER:
      return <Partners />;
    default:
      return null;
  }
};
